import React from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';

export const colors = {
  lead: '#7c4dff',
  carbon: '#FFF',
  primary: '#000',
  default: '#000',
  tertiary: '#DBDFF1',
  red: '#F4495D',
  green: '#06b66c',
  purple: '#BAB1FF',
  purple2: '#9A45D7',
  pink: '#FAF2F4',
  transparent: 'transparent',
  grey: 'rgba(0, 0, 0, 0.2)',
  grey2: '#F3F6F6',
  grey3: '#D9D9D9',
  grey4: '#939393',
  background: '#757676',
  white2: 'rgba(255, 255, 255, 0.2)',
  blue: 'blue',
};

const mapRoleToText = {
  success: 'green',
  light: 'grey4',
  primary: 'default',
  info: 'background',
  error: 'red',
  secondary: 'carbon',
};

const mapRoleToBackground = {
  success: 'green',
  primary: 'pink',
  white: 'carbon',
  info: 'tertiary',
  error: 'red',
  light: 'carbon',
  grey2: 'grey2',
  grey3: 'grey3',
  black: 'primary',
};

const mapRoleToBorder = {
  success: 'green',
  primary: 'purple',
  white: 'carbon',
  grey: 'grey',
  info: 'grey2',
  error: 'red',
  light: 'carbon',
  white2: 'white2',
  grey3: 'grey3',
  blue: 'blue',
};

export const mapRoleToTextColor = (role) =>
  colors[mapRoleToText[role] || 'primary'];

export const mapRoleToBackgroundColor = (role) =>
  colors[mapRoleToBackground[role] || 'transparent'];

export const mapRoleToBorderColor = (role) =>
  colors[mapRoleToBorder[role] || 'default'];

export const DEFAULT = {
  baseSpace: 4,
  mobile: 768,
  tablet: 1024,
  desktop: 1440,
};

export const Theme = ({ children }) => {
  return <ThemeProvider theme={DEFAULT}>{children}</ThemeProvider>;
};
